import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  serialNumber: values.serialNumber ?? '',
  purchaseDate: values.purchaseDate
    ? momentLocalTimezone(values.purchaseDate)
    : null,
  equipmentType: values.equipmentType ?? {},
  moreInfo: values.moreInfo ?? ''
});
